module.exports = __webpack_public_path__ + "static/media/serverless.98e38f82.png";